/* eslint-disable */

import React, { useEffect, useState } from "react";

import mainurl from "../config/mainurl.mjs";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

function ESignWidgetComponent() {
  const cc = secureLocalStorage.getItem("CC");
  const uid = secureLocalStorage.getItem("uid");
  const [Esignform, setEsignform] = useState("");
  const [Docket, setDocket] = useState("");
  const [Signer, setSigner] = useState();
  const [Document, setDocument] = useState();

  async function esignverify(Docketid, Docuid, result) {
    await fetch(`${mainurl}/esignverify`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: cc,
        uid: uid,
        docketid: `${Docketid}`,
        documentid: `${Docuid}`,
        rest: result,
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.message == "OK") {
          secureLocalStorage.setItem("status", `${uid}finish`);
          Navigate("/complete");
        } else {
          secureLocalStorage.setItem("status", `${uid}fail`);
          Navigate("/failed");
        }
      })
      .catch((error) => {});
  }

  const Navigate = useNavigate();
  async function esignapi() {
    await fetch(`${mainurl}/esign`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
      body: JSON.stringify({
        cc: cc,
        uid: uid,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let docket_id = result.docket_id;
        setDocket(docket_id);
        setSigner(result.signer_info[0].signer_id);
        setDocument(result.signer_info[0].document_id);
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  function esignfunc() {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://signdesk.in/api/eSignWidgetLive.js";
    script.async = true;
    script.onload = () => {
      const options = {
        id: "almondzglobalsecuritiesltd_esign_live",
        docket_id: `${Docket}`,
        signer_id: `${Signer}`,
        document_id: `${Document}`,
        widget_width: "90%",
        widget_height: "90%",
        getWidgetToken: function (result) {
          setEsignform(true);
          fetch(`${mainurl}/widgetverify`, {
            method: "POST",
            headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa" },
            body: JSON.stringify({
              token: result,
              docket: Docket,
            }),
          })
            .then((resp) => resp.json())
            .then((result) => {})
            .catch((error) => {
              // console.log(error);
            });
        },
        signatureStatus: function (result) {
          const Document_id = result.document_id;
          esignverify(Docket, Document, result);
        },
        errorLog: function (result) {
        },
      };
      try {
        if (typeof esignWidgetCall === "function") {
          esignWidgetCall(options);
        } else {
        }
      } catch (error) {}
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }

  // PREVENT TO REFRESH,BACK,AND ROUTES
  // ================================================
  window.onpopstate = (e) => {
    const confirmation = confirm("Are you Sure you Want to Cancel ?");
    if (confirmation === true) {
      Navigate("/");
      secureLocalStorage.clear();
    } else {
      Navigate("/esign");
    }
  };

  // ==============================================================================

  useEffect(() => {
    esignfunc();
  }, [Docket]);
  useEffect(() => {
    if (secureLocalStorage.getItem("status") !== `${uid}esfc`) {
      secureLocalStorage.clear();
      Navigate("/");
    }
    esignapi();
  }, []);

  return (
    <>
      <button className="link-text absolute flex items-center text-sm bottom-4 left-2 md:left-10">
        <Icon icon="mdi:arrow-left" color="gray" />
        <Link
          to="https://almondztrade.com/"
          onClick={() => secureLocalStorage.clear()}
        >
          Back to home
        </Link>
      </button>
      <div className="flex justify-center items-center w-3/4 h-3/4 m-auto">
        {Esignform === "" ? (
          <div>
            <p className="w-fit m-auto">
              <Icon
                icon="svg-spinners:6-dots-scale"
                color="orange"
                width="50"
                height="50"
              />
            </p>
            <p className="mt-2">Processing To Esign</p>
          </div>
        ) : (
          <div>
            <p className="w-fit m-auto">
              <Icon
                icon="svg-spinners:3-dots-fade"
                color="orange"
                width="50"
                height="50"
              />
            </p>
            <p className="mt-2">Wait For Few Second</p>
          </div>
        )}
      </div>
    </>
  );
}

export default ESignWidgetComponent;
